import { render, staticRenderFns } from "./MaridajeGold.vue?vue&type=template&id=0c452a24&scoped=true&"
import script from "./MaridajeGold.vue?vue&type=script&lang=js&"
export * from "./MaridajeGold.vue?vue&type=script&lang=js&"
import style0 from "./MaridajeGold.vue?vue&type=style&index=0&id=0c452a24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c452a24",
  null
  
)

export default component.exports